function initAnnouncementSlider() {
  // Log for debugging
  console.log("Swiper initialized for section: ");

  // Initialize Swiper
  new Swiper('.u-coll-swiper', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    grabCursor: true,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });
}